export default {
  DENIEDWARRANTY: 10,
  WILLCALL: 15,
};
